<template>
  <div class="buyer-contract" v-loading="fuck_loading" element-loading-background="rgba(255, 255, 255, 0.95)">
    <div class="buyer-top">
      <div class="top-con">
        <div class="container">
          <img src="@/assets/image/Contract/title.png"/>
          <span>订单编号：{{ buyerForm.order_sn }}</span>
        </div>
        <div class="logo"></div>
      </div>
    </div>
    <div class="buyer-main">
      <div class="form">
        <el-form ref="form" label-position="top" label-width="200px" :model="buyerForm" :rules="rules">
          <!-- <div class="contract_order_sn">
            订单编号：{{ buyerForm.order_sn }}
          </div> -->
          <el-form-item label="选择保障证明类型" prop="sign_way" class="contract_radio sign_way_wrapper" v-if="signWayShow">
            <div>
              <el-radio  label="1" v-model="buyerForm.sign_way">三方合同</el-radio>
              <span @click="quitVisible = true" class="sign_tip">查看示范图<i class="el-icon-question"></i></span>
              <div class="fdd-tip file-tip">
                <i class="el-icon-warning"></i>
                签署三方合同要求年满18周岁，否则无法通过审核。
              </div>
            </div>
            <div>
              <el-radio  label="2" v-model="buyerForm.sign_way">包赔证明文件</el-radio>
              <span @click="signVisible = true" class="sign_tip">查看示范图<i class="el-icon-question"></i></span>
              <div class="fdd-tip file-tip">
                <i class="el-icon-warning"></i>
                须提供本人姓名和名下注册手机号码，选择包赔证明与三方合同享有相同权益。
              </div>
            </div>
          </el-form-item>
          <!-- <div class="fdd-tip file-tip" v-if="signWayShow">
            <div><i class="el-icon-warning"></i>温馨提示</div>
            {{buyerForm.sign_way=='2'||buyerForm.sign_way==''?'须提供本人姓名和名下注册手机号码，选择包赔证明与三方合同享有相同权益。':''}}
            {{buyerForm.sign_way=='1'||buyerForm.sign_way==''?'签署三方合同要求年满18周岁，否则无法通过审核。':''}}
          </div> -->
          <el-form-item prop="source" class="contract_radio">
            <div slot="label" class="item-label">
              <!-- <span> -->
                <i>您是从哪里知晓游严选游戏服务网的？</i>
                <i class="item-radio">(单选)</i>
              <!-- </span> -->
            </div>
            <el-radio  label="1" v-model="buyerForm.source">贴吧</el-radio>
            <el-radio  label="2" v-model="buyerForm.source">主播</el-radio>
            <el-radio  label="3" v-model="buyerForm.source">号商</el-radio>
            <el-radio  label="4" v-model="buyerForm.source">朋友推荐</el-radio>
            <el-radio  label="5" v-model="buyerForm.source">网页搜索</el-radio>
            <el-radio  label="6" v-model="buyerForm.source">小程序公众号</el-radio>
            <el-radio  label="7" v-model="buyerForm.source">抖音</el-radio>
            <el-radio  label="8" v-model="buyerForm.source">B站(bilbili)</el-radio>
            <el-radio  label="9" v-model="buyerForm.source">老客户</el-radio>
            <el-radio  label="10" v-model="buyerForm.source">微博</el-radio>
            <el-radio  label="0" v-model="buyerForm.source">其他</el-radio>
            <el-radio style="visibility: hidden" disabled label="11" v-model="buyerForm.source"></el-radio>
          </el-form-item>
          <el-form-item label="姓名" prop="name">
            <el-input v-model="buyerForm.name" placeholder="请填写姓名" :disabled="nameShow"></el-input>
          </el-form-item>
          <el-form-item label="身份证号" prop="card_id" v-if="buyerForm.sign_way == 1">
            <el-input v-model="buyerForm.card_id" placeholder="请填写身份证号" :disabled="cardIdShow"></el-input>
          </el-form-item>
          <el-form-item label="现住地址" prop="address" v-if="buyerForm.sign_way == 1">
            <el-input type="textarea" v-model="buyerForm.address" resize="none" :rows="3"
                placeholder="请输入详细地址"></el-input>
          </el-form-item>
          <el-form-item label="通讯地址" prop="card_address" v-if="buyerForm.sign_way == 1">
            <el-input type="textarea" v-model="buyerForm.card_address" resize="none" :rows="3"
                placeholder="请输入身份证上的地址"></el-input>
          </el-form-item>
          <el-form-item label="联系电话" prop="mobile">
            <el-input v-model="buyerForm.mobile" placeholder="请输入联系电话"></el-input>
          </el-form-item>
          <el-form-item label="电子邮箱(如没有邮箱请跳过)" prop="email" v-if="buyerForm.sign_way == 1">
            <el-input v-model="buyerForm.email" placeholder="请输入电子邮箱"></el-input>
          </el-form-item>
          <!-- <el-form-item label="法大大注册账号" prop="fdd_account">
            <el-input v-model="buyerForm.fdd_account" placeholder="请输入法大大注册账号"></el-input>
          </el-form-item> -->
          <!-- <el-form-item label="身份证照片" prop="frontIdPhoto" class="form-item-id-card">
            <div class="id-card">
              <el-upload
                v-loading="loading"
                action
                :disabled="!frontIdPhotoShow"
                :style="!frontIdPhotoShow ? 'cursor:not-allowed;' : ''"
                :auto-upload="false"
                :show-file-list="false"
                :on-change="upload">
                <div class="img-box" v-show="buyerForm.frontIdPhoto !== ''">
                  <img :src="frontIdPhoto_url">
                  <div class="mask" v-show="frontIdPhotoShow">
                    <span>重新上传</span>
                  </div>
                </div>
              </el-upload>
            </div>
          </el-form-item> -->
          <el-form-item label="备注信息" prop="note">
            <el-input type="textarea" v-model="buyerForm.note" resize="none" :rows="4" placeholder="请输入备注信息"></el-input>
          </el-form-item>
          <div class="fdd-tip">
            <img src="@/assets/image/Contract/fddTip.png"/>
            本平台电子合同由法大大提供技术支持
          </div>
        </el-form>
      </div>
      <div class="buyer-btn">
        <el-button @click="resetForm()" class="reset">重填</el-button>
        <el-button type="primary" @click="save()" class="sub">提交</el-button>
      </div>
      <div v-show="quitVisible" class="quit-mark" @click="quitVisible=false">
        <div class="quit-box">
          <i class="el-icon-close"></i>
          <img src="@/assets/image/Contract/threeContract.png"/>
          <div class="quit_btn" @click="goTherePdf">点击预览三方合同文件<i class="el-icon-arrow-right"></i></div>
        </div>
      </div>
      <div v-show="signVisible" class="quit-mark" @click="signVisible=false">
        <div class="quit-box">
          <i class="el-icon-close"></i>
          <img src="@/assets/image/Contract/signContract.png"/>
          <div class="quit_btn" @click="goSignPdf">点击预览包赔证明文件<i class="el-icon-arrow-right"></i></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {apiBuyerContract, apiSellCard, appUploadAuth, apiuserContract, apiContractDetails} from "../../request/API";
import * as imageConversion from 'image-conversion'
/**
 * 表单验证失败时 滚动到第一个error位置
 */
const scrollIntoView = (className = "is-error", block = "center") => {
    Promise.resolve().then(() => {
       const target = document.getElementsByClassName(className);
     if (target.length) {
        target[0].scrollIntoView({
           behavior: "smooth",
           block: block,
       });
    }
  });
};
export default {
  name: 'buyerContract',
  data() {
    return {
      quitVisible: false,
      signVisible: false,
      fuck_loading: true,
      loading: false,
      buyerForm: {
        contract_id: '',
        order_sn: '',
        name: '',
        card_id: '',
        address: '',
        card_address: '',
        mobile: '',
        email: '',
        fdd_account: '1',
        frontIdPhoto: '',
        note: '',
        source: '',
        sign_way: ''
      },
      signWayShow: true,
      frontIdPhoto_url: '',
      rules: {
        name: [
          {required: true, message: '请输入姓名', trigger: 'blur'},
          { max: 30, message: '姓名不得超过30个汉字', trigger: 'blur' }
        ],
        card_id: [
          {required: true, message: '请输入身份证号', trigger: 'blur'},
          { min: 18, max: 18, message: '请输入18位身份证号', trigger: 'blur' }
        ],
        address: [
          {required: true, message: '请输入现住地址', trigger: 'blur'},
          { min: 5, max: 100, message: '请输入5~100个字的准确现住地址', trigger: 'blur' }
        ],
        card_address: [
          {required: true, message: '请输入通讯地址', trigger: 'blur'},
          { min: 5, max: 100, message: '请输入5~100个字的准确通讯地址', trigger: 'blur' }
        ],
        mobile: [
          {required: true, message: '请输入联系电话', trigger: 'blur'},
          {min:11, max: 11, message: '请输入11位手机联系号码', trigger: 'blur' }
        ],
        email: [
          { max: 50, message: '邮箱地址不得超过50位', trigger: 'blur' }
          // {required: true, message: '请输入电子邮箱', trigger: 'blur'},
        ],
        // fdd_account: [
        //   {required: true, message: '请输入法大大注册账号', trigger: 'blur'},
        // ],
        // frontIdPhoto: [
        //   {required: true, message: '请上传身份证照片', trigger: 'change'},
        // ],
        source: [
          {required: true, message: '请选择选项', trigger: 'change'},
        ],
        sign_way: [
          {required: true, message: '请选择证明文件类型', trigger: 'change'},
        ],
      },
      isSave: false,
      nameShow: true,
      frontIdPhotoShow: true,
      cardIdShow: true,
      userToken: '',
      app_status: 1,
      fdd_auth: 0
    }
  },
  created() {
    this.userToken = this.$route.query?.t || this.$route.query?.token
    this.buyerForm.contract_id = this.$route.query.contract_id
    if(this.userToken){
      let status = true
      this.$store.commit('set_token', this.userToken)
      this.$store.commit('set_loginStatus', status)
      this.app_status = 2
    } else{
      if (this.$store.state.loginStatus) {
        this.app_status = 1
      } else{
        this.$router.push({
          path: '/login',
          query: {
            Rurl: this.$route.path+'?contract_id='+this.buyerForm.contract_id,
          },
        })
        return;
      }
    }
    this.buyerForm.sign_way = ''
    this.signWayShow = true
    apiuserContract(this.app_status).then(res => {
      this.buyerForm.name = res.data.name || ''
      // this.buyerForm.name == '' ? this.nameShow = false : this.nameShow = true
      this.buyerForm.card_id = res.data.card_id || ''
      // this.buyerForm.card_id == '' ? this.cardIdShow = false : this.cardIdShow = true
      this.buyerForm.address = res.data.address || ''
      this.buyerForm.card_address = res.data.card_address || ''
      this.buyerForm.email = res.data.email || ''
      this.buyerForm.fdd_account = res.data.fdd_account || '1'
      this.frontIdPhoto = res.data.frontIdPhoto || ''
      this.frontIdPhoto_url = res.data.frontIdPhoto_url || ''
      this.frontIdPhoto_url == '' ? this.frontIdPhotoShow = true : this.frontIdPhotoShow = false
      this.buyerForm.note = res.data.note || ''
      this.buyerForm.mobile = res.data.mobile || ''
      this.fdd_auth = res.data.fdd_auth || 0

      this.nameShow = this.fdd_auth == 1 ? true : false
      this.cardIdShow = this.fdd_auth == 1 ? true : false
      // this.nameShow = false
      // this.cardIdShow = false
    })
    // 获取订单编号
    apiContractDetails(this.app_status,{contract_id: this.$route.query.contract_id,iden:1}).then(res => {
      this.buyerForm.order_sn = res.data.order_sn
      let is_benefit = res.data.is_benefit
      if(is_benefit == 2){
        this.buyerForm.sign_way = '1'
        this.signWayShow = false
      }
      setTimeout(() => {
        this.fuck_loading = false
      },400)
      let already = res.data.buy_user_id
      if (this.$store.state.loginStatus){
        if(this.userToken){
          if(already !== null && already !=='' && already !== 0){
            location.href = `/submitSuccess?contract_id=${this.buyerForm.contract_id}&type=1&already=1&app_status=${this.app_status}&sign_way=${res.data.sign_way}`
          }
        } else {
          let tel = res.data.buy_nickname
          if(tel != this.$store.state.userData.telphone){
            let telStart = tel.substring(0,3)
            let telEnd = tel.substring(7,11)
            this.$alert('当前用户无此合同编号，请重新登录'+ telStart + '****' + telEnd +'后填写',{
              confirmButtonText: '确定',
              center: true,
              showClose: false
            }).then(() => {
              this.$router.push({
                path: '/login',
                query: {
                  Rurl: this.$route.path+'?contract_id='+this.buyerForm.contract_id,
                },
              })
            }).catch(() => {})
            setTimeout(() => {
              let dom = document.querySelector('.v-modal')
              if(dom){
                dom.style.opacity= '.93'
              }
            },400)
          }else{
            if(already !== null && already !=='' && already !== 0){
              location.href = `/submitSuccess?contract_id=${this.buyerForm.contract_id}&type=1&already=1&app_status=${this.app_status}&sign_way=${res.data.sign_way}`
            }
          }
        }
      } else{
        this.$router.push({
          path: '/login',
          query: {
            Rurl: this.$route.path+'?contract_id='+this.buyerForm.contract_id,
          },
        })
      }

    }).catch(err => {
      this.fuck_loading = false
      if(err && err.code == 10001){
        this.$message({
          message: err.msg,
          center: true,
          offset: 200,
          customClass: 'sell-contract-msg'
        })
        setTimeout(() => {
          this.$router.push({
            path: '/login',
            query: {
              Rurl: this.$route.path+'?contract_id='+this.buyerForm.contract_id,
            },
          })
        }, 3000)
      }else{
        this.$message({
          message: (err && err.msg) || '合同详情获取失败，请稍后重试',
          center: true,
          offset: 200,
          customClass: 'sell-contract-msg'
        })
      }
    })
    // this.buyerForm.mobile = this.$store.state.userData.telphone
  },
  watch: {
    'buyerForm.sign_way'(v){
      this.$refs['form'].clearValidate()
    }
  },
  methods: {
    goTherePdf(){
      window.open('https://images.pxb7.com/file/contract.pdf','_blank')
    },
    goSignPdf() {
      window.open('https://images.pxb7.com/file/indemnity.pdf','_blank')

    },
    /**
     * @description: 生成唯一标识
     * @return {*}
     */
    uuid() {
        let s = [];
        let hexDigits = "0123456789abcdef";
        for (let i = 0; i < 36; i++) {
            s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
        }
        s[14] = "4"; // bits 12-15 of the time_hi_and_version field to 0010
        s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1); // bits 6-7 of the clock_seq_hi_and_reserved to 01
        s[8] = s[13] = s[18] = s[23] = "-";
        let uuid = s.join("");
        return uuid;
    },
    async upload(file) {
      this.loading = true
      const isJPG = file.raw.type === 'image/jpeg' || file.raw.type === 'image/png';
      const isLt5M = file.size / 1024 / 1024 < 5;
      if (!isJPG) {
        this.$message({
          message: '上传图片只能是 JPG/PNG 格式!',
          center: true,
          offset: 200,
          customClass: 'sell-contract-msg'
        })
      }
      // if (!isLt5M) {
      //   this.$message({
      //     message: '上传图片大小不能超过 5MB!',
      //     center: true,
      //     offset: 200,
      //     customClass: 'sell-contract-msg'
      //   })
      // }
     let newFile = await imageConversion.compressAccurately(file.raw, {
        size: 900,
        type: 'image/jpeg'
      })
      let blob_file = new File([newFile],this.uuid()+".jpeg",{type:file.type,lastModified: Date.now()})
      this.$getBase64(newFile).then(res => {
        appUploadAuth(this.app_status,{
          file:res
        }).then(res=>{
          let formData = new FormData()
          formData.append('file', blob_file)
          apiSellCard(this.app_status,formData).then(resp => {
            this.buyerForm.frontIdPhoto = resp.data.uri
            this.frontIdPhoto_url = resp.data.url
            this.buyerForm.name = res.data.cert_name
            this.buyerForm.card_id = res.data.cert_id
            if(this.buyerForm.name == '' || this.buyerForm.card_id == ''){
              this.frontIdPhoto_url = ''
              this.$message({
                message: '验证失败，请重新上传',
                center: true,
                offset: 200,
                customClass: 'sell-contract-msg'
              })
            } else {
              // this.nameShow = true
              // this.cardIdShow = true
              this.frontIdPhotoShow = false
              this.$message({
                message: '验证通过',
                center: true,
                offset: 200,
                customClass: 'sell-contract-msg'
              })
            }
            this.loading = false
          }).catch(err => {
            this.$message({
              message: err.msg,
              center: true,
              offset: 200,
              customClass: 'sell-contract-msg'
            })
            this.loading = false
          })
        }).catch(err=>{
          this.$message({
            message: err.msg,
            center: true,
            offset: 200,
            customClass: 'sell-contract-msg'
          })
          this.loading = false
        })
      });
      // return;
      // if (e.target.files.length > 0) {
      //   let formData = new FormData()
      //   formData.append('file', e.target.files[0])
      //   apiSellCard(formData).then(res => {
      //     this.buyerForm.frontIdPhoto = res.data.file_path
      //   }).catch(err => {
      //     this.$message.error(err.msg)
      //   })
      // }
    },
    resetForm() {
      let name = this.buyerForm.name
      let card_id = this.buyerForm.card_id
      this.$refs['form'].resetFields();
      this.buyerForm.name = name
      this.buyerForm.card_id = card_id
      this.buyerForm.mobile = ''
      // this.nameShow = false
      // this.cardIdShow = false
      this.frontIdPhotoShow = true
    },
    save() {
      if (this.isSave) {
        return
      }
      this.$refs['form'].validate((valid) => {
        if (valid) {
          this.isSave = true
          let parmas = this.buyerForm
          parmas.return_url = ''
          if(parmas.sign_way == 2){
            delete parmas.card_id
            delete parmas.address
            delete parmas.card_address
            delete parmas.email
          }
          apiBuyerContract(this.app_status,parmas).then(res => {
            if(res.data.url){
              location.href = res.data.url
            }else{
              location.href = `/submitSuccess?contract_id=${this.buyerForm.contract_id}&type=1&app_status=${this.app_status}&sign_way=${this.buyerForm.sign_way}`
            }
            this.isSave = false
          }).catch(err => {
            this.$message({
              message: err.msg,
              center: true,
              offset: 200,
              customClass: 'sell-contract-msg'
            })
            this.isSave = false
          })
        }else{
          scrollIntoView()
          this.$message({
            message: '还有未填项',
            center: true,
            offset: 200,
            customClass: 'sell-contract-msg'
          })
        }
      })
    }
  }
}
</script>

<style lang="less">
@import "./styles/contractFeedback.less";
</style>

<style lang="less" scoped>
@import "./styles/contractFormPage.less";

.contract-form-page(72px, buyer-contract, buyer-top, buyer-main, buyer-btn);

.buyer-contract {
  .buyer-main {
    .form {
      /deep/ .sign_way_wrapper {
        .el-form-item__content {
          flex-direction: column;
        }

        .sign_tip {
          font-size: 12px;
          font-family: PingFang SC-Regular, PingFang SC;
          font-weight: 400;
          color: #838383;
          margin-left: 10px;
          cursor: pointer;

          i {
            margin-left: 4px;
          }

          &:hover {
            color: #D8D2CA;
          }
        }
      }

      .id-card {
        background-image: url("~@/assets/image/Contract/IDCard1.jpg");
      }

      .file-tip {
        padding: 10px 16px;
        border-radius: 4px;
        font-size: 12px;
        line-height: 20px;
        font-family: PingFang SC-Regular, PingFang SC;
        font-weight: 400;
        color: #D06666;
        height: auto;
        background: #FFF6F6;
        border: 1px solid #FFDCDC;
        margin: 0 0 20px;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: flex-start;

        i {
          margin-right: 8px;
          font-size: 14px;
        }
      }
    }
  }

  .quit-mark {
    position: fixed;
    z-index: 999999;
    width: 100vw;
    height: 100vh;
    left: 0;
    top: 0;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    .quit-box {
      max-width: 359px;
      background: #ffffff;
      border-radius: 4px;
      box-sizing: border-box;
      position: relative;

      img {
        width: 100%;
        height: 100%;
      }

      .el-icon-close {
        position: absolute;
        right: 10px;
        top: 10px;
        font-size: 20px;
        font-weight: bold;
        color: #fff;
      }

      .quit_btn {
        cursor: pointer;
        position: absolute;
        left: calc(50% - 130px);
        bottom: 20px;
        width: 259px;
        height: 25px;
        line-height: 25px;
        text-align: center;
        background: #FFCE51;
        border: 1px #000 solid;
        border-radius: 4px;
        font-weight: bold;
        font-family: PingFang SC-Medium, PingFang SC;
        font-size: 12px;

        .el-icon-arrow-right {
          background: #000;
          color: #fff;
          width: 14px;
          height: 14px;
          line-height: 14px;
          border-radius: 50%;
          margin-left: 5px;
          display: inline-block;
          text-align: center;
        }
      }
    }
  }
}
</style>
